// extracted by mini-css-extract-plugin
export default {"Faq":"Faq_Faq__jNmir","Faq_title":"Faq_Faq_title__kElcj","Faq_subtitle":"Faq_Faq_subtitle__PlvG2"};